export default function BenefitsSection() {
  const tradieBenefits = [
    {
      icon: 'ri-search-line',
      title: 'Find Jobs Faster',
      description: 'AI matches you with relevant jobs based on your trade, location, and availability'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Clear Job Details',
      description: 'Every job comes with AI-generated scope, materials list, and budget estimate'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Fair Pricing',
      description: 'AI provides market-rate estimates so you can quote competitively and profitably'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Verified Clients',
      description: 'All clients are verified with ratings and payment history visible upfront'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Flexible Schedule',
      description: 'Choose jobs that fit your calendar and work on your own terms'
    },
    {
      icon: 'ri-secure-payment-line',
      title: 'Secure Payments',
      description: 'Get paid through the platform with milestone payments and dispute protection'
    }
  ];

  const clientBenefits = [
    {
      icon: 'ri-robot-2-line',
      title: 'AI Job Creation',
      description: 'Describe your project in plain English, AI creates a detailed job listing instantly'
    },
    {
      icon: 'ri-calculator-line',
      title: 'Instant Budget Estimate',
      description: 'Get AI-powered cost estimates before you even post the job'
    },
    {
      icon: 'ri-team-line',
      title: 'Multiple Quotes',
      description: 'Receive proposals from qualified tradies and compare pricing and timelines'
    },
    {
      icon: 'ri-star-line',
      title: 'Rated Tradies',
      description: 'See ratings, reviews, and completed jobs before hiring anyone'
    },
    {
      icon: 'ri-message-3-line',
      title: 'Direct Communication',
      description: 'Chat with tradies, share photos, and clarify details before committing'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Quality Guarantee',
      description: 'Platform protection with milestone payments and dispute resolution'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-700 px-4 py-2 rounded-full text-sm font-medium mb-4">
            <i className="ri-gift-line"></i>
            <span>Benefits for Everyone</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Built for Tradies & Clients
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our AI-powered marketplace creates value for both sides of every job
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* For Tradies */}
          <div>
            <div className="bg-gradient-to-br from-orange-600 to-amber-600 rounded-2xl p-8 mb-8 text-white">
              <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-tools-fill text-4xl"></i>
              </div>
              <h3 className="text-3xl font-bold mb-2">For Tradies</h3>
              <p className="text-orange-100">Find quality jobs with clear scope and fair pay</p>
            </div>

            <div className="space-y-6">
              {tradieBenefits.map((benefit, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
                    <i className={`${benefit.icon} text-2xl text-orange-600`}></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-1">{benefit.title}</h4>
                    <p className="text-gray-600">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* For Clients */}
          <div>
            <div className="bg-gradient-to-br from-blue-600 to-indigo-600 rounded-2xl p-8 mb-8 text-white">
              <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-home-smile-fill text-4xl"></i>
              </div>
              <h3 className="text-3xl font-bold mb-2">For Clients</h3>
              <p className="text-blue-100">Post jobs easily and hire trusted tradies</p>
            </div>

            <div className="space-y-6">
              {clientBenefits.map((benefit, index) => (
                <div key={index} className="flex gap-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <i className={`${benefit.icon} text-2xl text-blue-600`}></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-bold text-gray-900 mb-1">{benefit.title}</h4>
                    <p className="text-gray-600">{benefit.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}